import i18next from "i18next"
import common_es from "./es/common.json"
import common_en from "./en/common.json"
import common_fr from "./fr/common.json"

// Se debe inicializar el componente i18next
i18next.init({
    interpolation: {escapeValue: false}, 
    lng: 'en', // lenguaje defecto de la aplicación
    resources:{ // se configuran los recursos que soportará la aplicación apuntando a los recursos existentes
      en: {
        common: common_en
      },
      es:{
        common: common_es
      },
      fr:{
        common: common_fr
      },
    },
  });

  export default i18next